import { useState, useEffect } from "react";
import { createModel } from "hox";
import useStorageState from "@/hooks/useStorageState";
import { globalPrompt } from "@/components/message";
import { dictService, IVRM2DictDetail, IVRM2DictSearchs } from "./dictService";
import { forFind } from "@/utils/utils";
import { DictCodeEnmu, sourceAppOrBranch } from "../../../types/VrmSaDictEnums"
import useGlobalModel from "@/model/globalModel";
import { message } from "antd";

type dictObj = {
    [key: string]: any
}
type ISelectOptions = {
    label: string,
    value: string,
    relationvalue?: string,//关联的Value值
    [key: string]: any
}
export type ITreeSelectData = {
    title: string,
    value: string,
    children: ITreeSelectData[]
    [key: string]: any
}
function listChangeTree(list: IVRM2DictDetail[]) {
    let menuObj: dictObj = {}
    list.forEach(item => {
        item.children = []
        menuObj[item.code] = item
    })
    return list.filter(item => {
        if (item.pcode !== null && item.pcode !== "") {
            menuObj[item.pcode]?.children.push(item)
            return false
        }
        return true
    })
}

export const useDictModel = createModel(function () {
    const { shopAndOrg: { shopCode } } = useGlobalModel()
    const [treeSource, setTreeSource, clearTreeSource] = useStorageState<IVRM2DictDetail[]>("dictTree", []);  //字典数据源
    const [selectedNodes, setSelectedNodes] = useState<IVRM2DictDetail[]>([]);   //树选中的行信息
    const [mode, setMode] = useState<"add" | "edit" | "nextInsert" | "">("");
    const [formVal, setFormVal] = useState<IVRM2DictDetail>(selectedNodes[0]);  //表单缓存
    const [loading, setLoading] = useState(false);
    const [mdmLoading, setMdmLoading] = useState(false);
    const [dataList, setDataList] = useState<any>([]);   //树选中的行信息
    //实时缓存
    const onChangeFormVal = (changedValues: { [key: string]: any }) => {
        setFormVal({ ...formVal, ...changedValues });
    }

    const initDictFormFields = {
        pcode: "",
        code: "",
        name: "",
        note: "",
        ver: 0,
        sourceAuthKey: "",
        children: [],
        enable: 1,
        branch: "",
        value: "",
        key: "",
        isCurrency: 1
    }
    useEffect(() => {
        if (mode === "add") {
            setFormVal({ ...selectedNodes[0], ...initDictFormFields, pcode: selectedNodes[0].pcode, shopCode: [] })
        } else if (mode === "nextInsert") {
            setFormVal({ ...selectedNodes[0], ...initDictFormFields, pcode: selectedNodes[0].code, shopCode: [] })
        }
    }, [mode])

    const loadData = async (shopCodes: string) => {
        let data: IVRM2DictSearchs = {
            "sourceApp": "vrm",
            // shopCode: shopCodes,
            // page: {
            //     pageSize: 10000000,
            //     pageNum: 1,
            // },
            pageSize: 10000000,
            pageNum: 1,
        }
        let { retData } = await dictService.pages(data);
        setDataList(retData)
        setTreeSource(listChangeTree(retData));
    }

    // 同步到主数据
    const sync = async () => {
        setLoading(true);
        try {
            let { retData } = await dictService.sync();
            message.success("同步成功");
            loadData(shopCode);
            setLoading(false)
        } catch {
            setLoading(false);
        }
    }

    // 从主数据同步
    const mdmSync = async () => {
        setMdmLoading(true);
        let data = {
            sourceApp: "vrm",
            "branchList": ["main", "vrm", "scm", "ci"]
        }
        try {
            let { retData } = await dictService.mdmSync(data);
            message.success("同步成功");
            loadData(shopCode);
            setMdmLoading(false)
        } catch {
            setMdmLoading(false);
        }
    }
    //表单提交
    const onSubmit = async () => {
        let { code, pcode, note, name, enable, nameEn, status, value, isCurrency } = formVal;
        let data = {
            ...sourceAppOrBranch,
            branch: "main",
            code, pcode, note, name, nameEn, value,
            isCurrency: pcode ? null : isCurrency ? 1 : 0,
            enable: enable ? 1 : 0
        }
        if (!data.code) {
            globalPrompt("message", { text: "编码为必填项", type: "warning" });
            return;
        }
        if (mode === "add" || mode === "nextInsert") {
            let { retData } = await dictService.insert(data);
            if (retData) {
                globalPrompt("message", { type: "success", text: "字典增加成功" });
            }
            loadData(shopCode);
            setSelectedNodes([]);
        } else if (mode === "edit") {
            let { retData } = await dictService.update(data);
            if (!!retData) {
                globalPrompt("message", { type: "success", text: "字典编辑成功" });
            }
            loadData(shopCode);
            setSelectedNodes([]);
        }
    }
    const onLocalSubmit = async () => {
        let { code, pcode, note, name, enable, nameEn, status, value, shopCode, key, isCurrency } = formVal;

        let data = {
            ...sourceAppOrBranch,
            branch: "main",
            code, pcode, note, name, nameEn, value,
            isCurrency: pcode ? null : isCurrency ? 1 : 0,
            shopCode: shopCode.toString(),
            enable: enable ? 1 : 0
        }
        if (!data.code) {
            globalPrompt("message", { text: "编码为必填项", type: "warning" });
            return;
        }
        if (mode === "add" || mode === "nextInsert") {
            let nameList = dataList.filter((item: any) => item.pcode === pcode)?.map((item: any) => item.name)
            if (nameList.includes(name)) {
                return message.error("该父级下已存在该名称,请编辑!")
            }
            // let { retData } = await dictService.insertLocal(data);
            let { retData } = await dictService.shopInsert(data);
            if (!!retData) {
                globalPrompt("message", { type: "success", text: "字典增加成功" });
            }
            loadData(shopCode);
            setSelectedNodes([]);
        } else if (mode === "edit") {
            // let { retData } = await dictService.updateLocal(data);
            let { retData } = await dictService.shopUpdate({ ...data, key });
            if (retData) {
                globalPrompt("message", { type: "success", text: "字典编辑成功" });
            }
            loadData(shopCode);
            setSelectedNodes([]);
        }
    }
    //删除一条数据
    const removeOneDict = async (code: string) => {
        let data = {
            ...sourceAppOrBranch,
            code
        }
        let { retData } = await dictService.remove(data);
        if (retData) {
            globalPrompt("message", { type: "success", text: "字典删除成功" });
        }

        loadData(shopCode);
        setSelectedNodes([]);
    }

    //根据code返回 select框的options 格式；
    const getSelectedDictOne = (code: string, branch?: string[]): any => {
        if (!code) return [];
        let findTree: IVRM2DictDetail | undefined = forFind(treeSource, code, "code");
        let tempArr: ISelectOptions[] = [];
        if (!findTree) return [];
        if (code === 'purchase-type') {
        }
        findTree.children?.forEach((item) => {
            // if (item.branch === "vrm") {
            // if (branch) {
            //     if (branch.indexOf(item.branch) > -1) {
            //         tempArr.push(item.value ? { label: item.name, value: item.code, relationvalue: item.value } : { label: item.name, value: item.code })
            //     }
            // } else {
            if (item) {
                tempArr.push(item.value ? { label: item.name, value: item.code, relationvalue: item.value, disabled: item.enable == 0 ? true : false } : { label: item.name, value: item.code, disabled: item.enable == 0 ? true : false })
            }
            // }
            // if (item.enable && item.branch === defaultMdCmParam.branch) {
            // }
        })
        return tempArr;
        // let findTree: IVRM2DictDetail | undefined = forFind(treeSource, code, "code");
        // return findTree ? findTree.children.filter(filItem =>
        //     filItem.shopCode?.indexOf(shopCode) !== -1 && filItem && filItem.branch === "vrm"
        // ).map(item => {
        //     let { value } = item
        //     return value ? { label: item.name, value: item.code, relationvalue: value } : { label: item.name, value: item.code }
        // }) : []
    }

    //根据code 返回对应的node节点名称
    const getTreeNodeName = (code: string): string => {
        let obj: dictObj = {};
        let findTree: IVRM2DictDetail | undefined = forFind(treeSource, code, "code");
        return findTree ? findTree["name"] : "";
    }

    //根据code 返回对应树节点
    const getTreeNodeOne = (code: string): IVRM2DictDetail[] => {
        let findTree: IVRM2DictDetail | undefined = forFind(treeSource, code, "code");
        return findTree ? [findTree] : [];
    }

    const mapTree = (org: IVRM2DictDetail): ITreeSelectData => {
        const haveChildren = Array.isArray(org.children) && org.children.length > 0;
        return {
            title: org.name,
            value: org.code,
            pcode: org.pcode,
            //判断它是否存在子集，若果存在就进行再次进行遍历操作，知道不存在子集便对其他的元素进行操作
            children: haveChildren ? org.children.map(i => mapTree(i)) : []
        };
    }
    //根据code 返回treeSelect 数据格式
    const getTreeSelectOne = (code: DictCodeEnmu): ITreeSelectData[] => {
        let findTree: IVRM2DictDetail | undefined = forFind(treeSource, code, "code");
        return findTree ? mapTree(findTree).children : [];
    }
    return {
        /***field***/
        treeSource, loading,
        selectedNodes,
        mode,
        formVal,
        /***method***/
        setTreeSource, sync, mdmSync,
        setSelectedNodes,
        setMode,
        setFormVal,
        onChangeFormVal,
        loadData,
        onSubmit,
        getTreeNodeName,
        getSelectedDictOne,
        getTreeNodeOne,
        getTreeSelectOne,
        onLocalSubmit,
        mdmLoading, setMdmLoading,
        dataList, setDataList
    }
});
